import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const CTabs = ({ tabs, value, onChange, className = '' }) => {
    const handleChange = (event, newValue) => {
        onChange(newValue);
      };
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      className={`CTabs ${className}`}
      variant="scrollable"
      scrollButtons="auto"
      TabIndicatorProps={{ style: { display: 'none' } }}
    >
      {tabs.map((tab) => (
        <Tab key={tab.value} label={tab.label} value={tab.value} disabled={tab.disabled}  className='2xl:!text-base !text-sm 2xl:!leading-base !leading-sm !font-medium'/>
      ))}
    </Tabs>
  );
};

export const CTabPanel = ({ children, value, index, className = '', ...other }) => {
  const isVisible = value === index;
  // Only apply flex styles if className contains flex-related classes
  const hasFlexClasses = className.includes('flex') || className.includes('flex-1') || className.includes('min-h-0');
  const boxSx = hasFlexClasses 
    ? { height: '100%', display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }
    : { margin: 0, padding: 0 };
  
  return (
    <div
      role="tabpanel"
      hidden={!isVisible}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={isVisible ? className : ''}
      style={isVisible ? {} : { display: 'none' }}
      {...other}
    >
      {isVisible && (
        <Box className={className} sx={boxSx}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default CTabs;
